import { useState } from 'react';
import { Button, Modal, Box, CircularProgress, Typography, Grid, Autocomplete, Select, MenuItem, Checkbox, TextField } from '@mui/material';
import { Cancel } from '@mui/icons-material';
import { deepPurple } from '@mui/material/colors';
import TasklistModal from './TasklistModal';
import FilterTasklist from './FilterTasklist';
import TasklsitDataTable from './TasklsitDataTable';
import { axiosInstance } from 'utils/axios';
import { successAlert, errorAlert, warningAlert } from 'ui-component/Toasts';
import { selectCurrentToken } from 'features/auth/authSlice';
import { useSelector } from 'react-redux';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const InsertCustomerTasklistRecord = ({ tasklist, fetchTaskList, customerNameOptions, customerLoginUsernamesOptions, taskNameOptions, customerTasklistStatusList }) => {
    const token = useSelector(selectCurrentToken);

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [updateClientLoginUsername, setUpdateClientLoginUsername] = useState('');
    const [updateTaskName, setUpdateTaskName] = useState('');
    const [updateTaskNumber, setUpdateTaskNumber] = useState(0);
    const [updateCustomerTaskStatusID, setUpdateCustomerTaskStatusID] = useState(3);
    const [updateIsPackage, setUpdateIsPackage] = useState(true);

    // Combo tasklist related states
    const [updateIsCombo, setUpdateIsCombo] = useState(false);
    const [comboModalIsOpen, setComboModalIsOpen] = useState(false);
    const [selectedComboTaskIDs, setSelectedComboTaskIDs] = useState([]);
    const [tasklistFilterIsLoading, setTasklistFilterIsLoading] = useState(false);

    const [insertBtnDisabled, setInsertBtnDisabled] = useState(false);
    const [insertTasklistLoading, setInsertTasklistLoading] = useState(false);

    const handleComboModalClose = () => {
        setComboModalIsOpen(false);
    };

    const handleComboChange = (e) => {
        setUpdateIsCombo(e.target.checked);

        if (e.target.checked) {
            setComboModalIsOpen(true);
        } else {
            setSelectedComboTaskIDs([]);
        }
    };

    const handleClientLoginUsernameChange = (customerLoginUsername) => {
        setUpdateClientLoginUsername(customerLoginUsername);
        // fetchNextTaskNumber(clientName);
    };

    const insertCustomerTasklist = async () => {
        setInsertBtnDisabled(true);
        setTimeout(() => {
            setInsertBtnDisabled(false);
        }, 3000);
        setInsertTasklistLoading(true);
        console.log("dist doesn't ran");
        try {
            const res = await axiosInstance.post(
                '/CustomerTasklist',
                {
                    loginUsername: updateClientLoginUsername,
                    taskName: updateTaskName,
                    taskNumber: parseFloat(updateTaskNumber),
                    statusID: parseFloat(updateCustomerTaskStatusID),
                    isPackage: updateIsPackage,
                    taskCode: updateTaskName,
                    comboTasklistID: updateIsCombo ? selectedComboTaskIDs.toString() : null
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('Customer Tasklist inserted successfully.');
                // fetchCustomerTasklistRecord();
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setInsertTasklistLoading(false);
        }
    };

    return (
        <>
            <Button
                onClick={handleOpen}
                sx={{
                    border: 'none',
                    backgroundColor: deepPurple[500],
                    color: 'white',
                    marginLeft: 'auto',
                    marginBottom: '20px',
                    marginRight: '20px'
                }}
            >
                Insert Customer Tasklist
            </Button>

            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                {insertTasklistLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box sx={style}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Typography id="modal-modal-title" variant="h3" component="h2">
                                Insert Customer Tasklist
                            </Typography>
                            <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                        </Box>
                        <Box
                            id="modal-modal-description"
                            sx={{
                                height: '450px',
                                overflowY: 'auto'
                            }}
                        >
                            <Grid item container xs={12} sx={{ mt: 2 }}>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Login Username :
                                        </Typography>
                                        <Autocomplete
                                            freeSolo
                                            value={updateClientLoginUsername}
                                            onChange={(event, newValue) => {
                                                handleClientLoginUsernameChange(newValue);
                                            }}
                                            inputValue={updateClientLoginUsername}
                                            onInputChange={(event, newInputValue) => {
                                                handleClientLoginUsernameChange(newInputValue);
                                            }}
                                            id="controllable-states-demo"
                                            options={customerLoginUsernamesOptions}
                                            sx={{ width: 170 }}
                                            renderInput={(params) => <TextField {...params} />}
                                            disableClearable
                                        />
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Task Code :
                                        </Typography>
                                        <Autocomplete
                                            freeSolo
                                            value={updateTaskName}
                                            onChange={(event, newValue) => {
                                                setUpdateTaskName(newValue);
                                            }}
                                            inputValue={updateTaskName}
                                            onInputChange={(event, newInputValue) => {
                                                setUpdateTaskName(newInputValue);
                                            }}
                                            id="controllable-states-demo"
                                            options={taskNameOptions}
                                            sx={{ width: 170 }}
                                            renderInput={(params) => <TextField {...params} />}
                                            disableClearable
                                        />
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Task Number :
                                        </Typography>
                                        <input
                                            type="number"
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={updateTaskNumber}
                                            onChange={(e) => setUpdateTaskNumber(e.target.value)}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Status :
                                        </Typography>
                                        <Select
                                            displayEmpty
                                            value={updateCustomerTaskStatusID}
                                            onChange={(e) => setUpdateCustomerTaskStatusID(e.target.value)}
                                            // sx={{width:"100%"}}
                                        >
                                            <MenuItem sx={{ width: '100%' }} value="0">
                                                Select Status
                                            </MenuItem>
                                            {customerTasklistStatusList.map((item, index) => (
                                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Is Package :
                                        </Typography>
                                        <Checkbox checked={updateIsPackage} onChange={(e) => setUpdateIsPackage(e.target.checked)} />
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Is Combo :
                                        </Typography>
                                        <Checkbox checked={updateIsCombo} onChange={handleComboChange} />
                                    </Box>
                                </Grid>

                                <TasklistModal
                                    comboModalIsOpen={comboModalIsOpen}
                                    handleComboModalClose={handleComboModalClose}
                                    selectedComboTaskIDs={selectedComboTaskIDs}
                                    setSelectedComboTaskIDs={setSelectedComboTaskIDs}
                                    tasklist={tasklist}
                                    tasklistFilterIsLoading={tasklistFilterIsLoading}
                                    setTasklistFilterIsLoading={setTasklistFilterIsLoading}
                                    fetchTaskList={fetchTaskList}
                                />
                                <FilterTasklist
                                    fetchTaskList={fetchTaskList}
                                    setTasklistFilterIsLoading={setTasklistFilterIsLoading}
                                    tasklistFilterIsLoading={tasklistFilterIsLoading}
                                />
                                <TasklsitDataTable tasklist={tasklist} />
                            </Grid>
                        </Box>
                        <Button
                            variant="contained"
                            sx={{
                                display: 'block',
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: deepPurple[500],
                                marginTop: '50px'
                            }}
                            onClick={() => insertCustomerTasklist()}
                            disabled={insertBtnDisabled}
                        >
                            Insert Customer Tasklist
                        </Button>
                    </Box>
                )}
            </Modal>
        </>
    );
};

export default InsertCustomerTasklistRecord;
